import React from "react";
// import _ from "lodash";
import axios from "axios";
import Autosuggest from "react-autosuggest";
import { DATABOOK_API } from "../constants/serverConfig";
import ReusableCertifiedIcon from "../utils/ReUsableComponents/ReusableCertifiedIcon";
import NarbarSearchDropdown from "./NarbarSearchDropdown";
import { IoSearch } from "react-icons/io5"; 


var CancelToken = axios.CancelToken;
var cancel;
class AutocompleteDatasets extends React.Component {

  constructor() {
    super();

    this.state = {
      suggestions: [],
      selections: [],
      isLoading: false,
      isEnableClear: false,
    };
  }

  setSearchDropDownFilter = (value) => {
    this.props.setSearchKeyword({
      criteria: value,
      term: this.props.searchKeyword?.term
    })
  }

  getSuggestionValue = (suggestion) => {
    return suggestion.fqn;
  };

  renderSuggestion = (suggestion, { query }) => {
    let certifieddata = suggestion.certification?.certifiedFlag ? (
      <ReusableCertifiedIcon certifieddata={suggestion.certification} />
    ) : (
      ""
    );
    return (
      <div>
        <div><span>{suggestion.fqn?.substring(suggestion.fqn?.lastIndexOf(".") + 1)}</span> {certifieddata}</div>
        <div className="suggestion" key={suggestion.fqn}>
          <div className="d-inline-block">
            <em className="matches">{suggestion.fqn}</em>
          </div>
          <div className="dataset-name float-end">
            <span className="dataset-object">{suggestion.matchFields.toString()}</span>
          </div>
        </div>
      </div>
    );
  };

  loadSuggestionWithToken = async (value) => {
    const { token, getToken, error } = this.props.contextAuth;

    (async () => await getToken())();
    if (token) {
      await this.loadSuggestions(token, value);
    }
    if (error) {
      try {
        const rtoken = (await this.props.instance.acquireTokenRedirect(this.props.request))
          .accessToken;
        await this.loadSuggestions(rtoken, value);
      } catch (error) {
        console.log(error);
      }
    }
  }

  loadSuggestions = (token, value) => {
    this.setState({
      isLoading: true,
    });
    if (cancel !== undefined) {
      cancel();
    }
    let requestbody = {
      term: value,
      pageIndex: 1,
      pageSize: 1000,
    }

    this.lastRequestId = axios
      .post(`${DATABOOK_API}/search`, requestbody, {
        cancelToken: new CancelToken(function executor(c) {
          // An executor function receives a cancel function as a parameter
          cancel = c;
        }),
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
      .then((res) => {
        let fetchedatasets = [...res.data.results];
        this.setState({
          isLoading: false,
          suggestions: fetchedatasets,
        });
      })
      .catch((err) => {
        if (err?.message === "canceled") {
          this.setState({
            isLoading: true,
            suggestions: [],
          });
        } else {
          this.setState({
            isLoading: false,
            suggestions: [],
          });
        }
      });
  };

  onChange = (event) => {
    this.setState({

      isEnableClear: true,
    });
    this.props.setSearchKeyword({
      criteria: this.props.searchKeyword.criteria,
      term: event.target.value,
    });
  };


  onSuggestionsFetchRequested = ({ value }) => {
    if (value.length > 3) {
      // this.loadSuggestionWithToken(value);
    }
  };

  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: [],
    });
  };

  onSuggestionSelected = (evt, { suggestion }) => {
    this.setState({
      value: suggestion.fqn,
      selections: [suggestion],
    });
    this.props.navigateToDetailsPage(suggestion.fqn, suggestion?.assetType);
  };

  // onSubmitHandler = (e) => {
  //   e.preventDefault();
  //   if (e.target.searchinput.value) {
  //     this.props.setSearchKeyword({
  //       criteria: this.props.searchKeyword.criteria,
  //       term: this.props.searchKeyword.term
  //     })
  //     this.props.navigateToViewAllPage(this.props.searchKeyword.term);

  //   }
  // };

  //newone below
  onSubmitHandler = (e) => {
    e.preventDefault();
    const { criteria, term } = this.props.searchKeyword;
    if (e.target.searchinput.value) {
      this.props.setSearchKeyword({
        criteria,
        term,
      });
      this.props.navigateToViewAllPage(term, criteria);
    }
  };

  // searchButtonHandler = () => {

  //   const { criteria, term } = this.props.searchKeyword;
  //   console.log('jojo'); 
  //   this.props.setSearchKeyword({
  //     criteria: this.props.searchKeyword.criteria,
  //     term: this.props.searchKeyword.term
  //   })
  //   // this.props.navigateToViewAllPage(this.props.searchKeyword.term);
  //   this.props.navigateToViewAllPage(term, criteria);
  // } 
//newone below
  searchButtonHandler = () => {
    const { criteria, term } = this.props.searchKeyword;
    console.log('jojo'); 
    this.props.setSearchKeyword({
      criteria,
      term,
    });
    this.props.navigateToViewAllPage(term, criteria); // Pass both term and criteria
  };
  

  clearInput = () => {
    this.setState({
      searchKeyword: {
        criteria: "dataset-name",
        term: ""
      },
      isEnableClear: false,
    });
    this.props.setSearchKeyword({
      criteria: "dataset-name",
      term: ""
    });
  };

  render() {
    const { suggestions, isLoading } = this.state;
    const inputProps = {
      placeholder: "Search here",
      value: this.props.searchKeyword.term,
      onChange: this.onChange,
      id: "searchid",
      name: "searchinput",
    };

    return (
      <div className="wrapper">
        <section className="wrapper-input" >
          <div className="search-wrapper d-flex W-100" id="wrapper-id">
            <div className="drop-search w-25">
              <NarbarSearchDropdown
                setSearchDropDownFilter={this.setSearchDropDownFilter}
                defaultSelectedOnLoad={this.props.searchKeyword.criteria}
                tabcriteria={this.props.tabcriteria}
              />
            </div>
            <div className="search-bar w-75 " >
              <form onSubmit={this.onSubmitHandler}>
                {/* {isEnableClear ? (
                  <div id="icon" onClick={() => this.clearInput()}>
                    &#10006;
                  </div>
                ) : (
                  ""
                )} */}
                {isLoading ? (
                  <div>
                    <span className="loading-text">
                      <i>Loading...</i>
                    </span>
                  </div>
                ) : null}

                <input {...inputProps} 
                style={{ width: "100%" ,
                height: "34px",
                position: "relative",
                bottom: "1px",
              }}
                />
                {/* <Autosuggest
                  suggestions={suggestions}
                  onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                  // onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                  getSuggestionValue={this.getSuggestionValue}
                  // renderSuggestion={this.renderSuggestion}
                  // onSuggestionSelected={this.onSuggestionSelected}
                  inputProps={inputProps}
                /> */}
              </form>
            </div>
            <div className="div-search-btn"
            style={{
              position: "relative",
              bottom: "1px",
          }}
            >
              <button
                onClick={this.searchButtonHandler}
                className="btn search-btn"
                type="button"
              >
                <IoSearch />
              </button>
            </div>
          </div >

        </section >
      </div >
    );
  }
}

export default AutocompleteDatasets;
